import { createSlice } from "@reduxjs/toolkit";
import dateFormat from "dateformat";
import { AG_FROM_DATE, AG_TO_DATE } from "../../../Utils/FilterDateKeys";
import { AffinityGroupFieldsJSON } from "../../../pages/AG/AffinityGroup/Json/AffinityGroupFieldsJson";

const enterpriseid = localStorage.getItem("enterpriseid");
const initialState = {
  affinityGroupData: [],
  sorting: {
    column: "created_date",
    order: "DESC",
  },
  agSwitch: {
    id: null,
  },
  agFieldJson: AffinityGroupFieldsJSON,
  agCategoryDropdown: [],
  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [AG_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [AG_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
};

const affinityGroupSlice = createSlice({
  name: "affinityGroup",
  initialState,
  reducers: {
    setAffinityGroupData(state, action) {
      state.affinityGroupData = action.payload;
    },
    setAgFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    setAgFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // [AG_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [AG_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // enterpriseid: enterpriseid,
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[AG_FROM_DATE];
          delete state.filter.form[AG_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setAgFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setAgSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setAgSwitch(state, action) {
      state.agSwitch.id = action.payload;
    },
    setAgFieldJson(state, action) {
      state.agFieldJson = action.payload;
    },
    setAgCategoryDropdown(state, action) {
      state.agCategoryDropdown = action.payload;
    },
  },
});

export const {
  setAffinityGroupData,
  setAgFilterApi,
  setAgFilterForm,
  setAgFilterFormCopy,
  setAgSorting,
  setAgSwitch,
  setAgCategoryDropdown,
  setAgFieldJson,
} = affinityGroupSlice.actions;

export default affinityGroupSlice.reducer;
